import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import "../styles/CompleteProfile.css";

const CompleteProfile0 = () => {
  const [user] = useAuthState(auth);
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTermsStatus = async () => {
      if (user) {
        try {
          const userDocRef = doc(db, "members", user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists() && userDocSnap.data().terms) {
            navigate("/complete-profile1"); // すでに同意済みなら次へ
          }
        } catch (err) {
          console.error("利用規約の状態取得エラー:", err);
          setError("利用規約の状態を取得できませんでした。");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchTermsStatus();
  }, [user, navigate]);

  const handleAgree = async () => {
    if (!user) {
      setError("ユーザー情報を取得できませんでした。");
      return;
    }

    try {
      const userDocRef = doc(db, "members", user.uid);
      await updateDoc(userDocRef, {
        terms: true,
      });

      navigate("/complete-profile1"); // 同意後、次のページへ
    } catch (err) {
      console.error("利用規約同意の更新エラー:", err);
      setError("利用規約の同意を保存できませんでした。");
    }
  };

  return (
    <div className="complete-profile-container">
      <ProgressBar step={0} totalSteps={6} />

      <h2>利用規約の確認</h2>
      {error && <p className="error-message">{error}</p>}
      {loading ? (
        <p>読み込み中...</p>
      ) : (
        <>
          <div className="terms-content">
            <h3>利用規約</h3>
            <p>ここに利用規約の内容を表示します...</p>
            <p>
              詳細は <a href="/terms" target="_blank" rel="noopener noreferrer">利用規約ページ</a> をご覧ください。
            </p>

            <h3>プライバシーポリシー</h3>
            <p>ここにプライバシーポリシーの内容を表示します...</p>
            <p>
              詳細は <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">プライバシーポリシーページ</a> をご覧ください。
            </p>
          </div>

          <div className="checkbox-container">
            <input
              type="checkbox"
              id="agreeTerms"
              checked={isAgreed}
              onChange={() => setIsAgreed(!isAgreed)}
            />
            <label htmlFor="agreeTerms">利用規約とプライバシーポリシーに同意する</label>
          </div>

          <button onClick={handleAgree} className="complete-profile-button" disabled={!isAgreed}>
            同意して次へ
          </button>
        </>
      )}
    </div>
  );
};

export default CompleteProfile0;
